import React from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import {
  CreateUpdateApplicationDto,
  CreateUpdateClientDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface AddressFormFieldsProps {
  client: CreateUpdateClientDto | CreateUpdateApplicationDto;
  propertyChange?: (obj: Partial<CreateUpdateClientDto>) => void;
  readonly?: boolean;
}

export const AddressFormFields: React.FC<AddressFormFieldsProps> = props => {
  const { t, tk } = useTranslation('clientLng');

  return (
    <>
      <FormRow controlId="postcode" label={t(tk.client.postcode)}>
        <Form.Control
          type="text"
          value={props.client?.postcode || ''}
          onChange={e =>
            props.propertyChange &&
            props.propertyChange({ postcode: e.target.value })
          }
          disabled={props.readonly}
        />
      </FormRow>

      <FormRow controlId="place" label={t(tk.client.place)}>
        <Form.Control
          type="text"
          value={props.client?.place || ''}
          onChange={e =>
            props.propertyChange &&
            props.propertyChange({ place: e.target.value })
          }
          disabled={props.readonly}
        />
      </FormRow>

      <FormRow controlId="street" label={t(tk.client.street)}>
        <Form.Control
          type="text"
          value={props.client?.street || ''}
          onChange={e =>
            props.propertyChange &&
            props.propertyChange({ street: e.target.value })
          }
          disabled={props.readonly}
        />
      </FormRow>

      <FormRow controlId="numbers" label={t(tk.client.numbers)}>
        <Form.Control
          type="text"
          value={props.client?.numbers || ''}
          onChange={e =>
            props.propertyChange &&
            props.propertyChange({ numbers: e.target.value })
          }
          disabled={props.readonly}
        />
      </FormRow>

      <FormRow controlId="flat" label={t(tk.client.flat)}>
        <Form.Control
          type="text"
          value={props.client?.flat || ''}
          onChange={e =>
            props.propertyChange &&
            props.propertyChange({ flat: e.target.value })
          }
          disabled={props.readonly}
        />
      </FormRow>

      {/* <FormRow controlId="addressEx" label={t(tk.client.addressEx)}>
        <Form.Control
          as="textarea"
          rows={2}
          value={props.client?.addressEx || ''}
          onChange={e =>
            props.propertyChange &&
            props.propertyChange({ addressEx: e.target.value })
          }
          disabled={props.readonly}
        />
      </FormRow> */}
    </>
  );
};
